module.exports = __webpack_public_path__ + "static/media/mp4.eb6baddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/mp4.png
// module id = 508
// module chunks = 0